module.exports = __webpack_public_path__ + "static/media/icon_radio_select.550a57d8.svg";